<div *ngIf="(loading$ | async)" class="dialog-loading">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{ 'modules.billing.counterParty.viewDialog.title' | translate }}</div>
    <div (click)="closeDialog(false)" class="dialog-close">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content tab-container">
    <div class="tab-actions-container">

<!--        && checkPermissions('ASSOCIATION_EDIT') || checkPermissions('ASSOCIATION_DELETE')-->
        <button class="action-button gray"
                style="height: 32px; width: 32px; padding: 0"
                [matMenuTriggerFor]="counterpartyItemMenu"
                *ngIf="counterpartyTabs.selectedIndex === 0 ">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #counterpartyItemMenu xPosition="before">
            <button mat-menu-item class="item-action-button gray"
                    (click)="editCounterparty()"
                    *ngIf="checkPermissions('ASSOCIATION_EDIT')">
                <mat-icon>edit_note</mat-icon>
                <span>{{'common.buttons.edit' | translate}}</span>
            </button>
            <button mat-menu-item class="item-action-button gray"
                    (click)="deleteCounterparty()"
                    *ngIf="checkPermissions('ASSOCIATION_DELETE')">
                <mat-icon>delete_outline</mat-icon>
                <span>{{'common.buttons.delete' | translate}}</span>
            </button>
        </mat-menu>

        <button *ngIf="counterpartyTabs.selectedIndex === 1"
                [matMenuTriggerFor]="addGovernmentMenu"
                class="action-button green">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'common.addItem' | translate }}</span>
        </button>

        <mat-menu #addGovernmentMenu class="wide-menu" xPosition="before">
            <button (click)="addItem(counterpartyTabs.selectedIndex, {formType: 'setGroupMainAdmin'})" *ngIf="canAddMainAdmin"
                    class="item-action-button gray"
                    mat-menu-item>
                <mat-icon>settings_accessibility</mat-icon>
                <span>{{ 'Головний адміністратор' | translate }}</span>
            </button>
            <button (click)="addItem(counterpartyTabs.selectedIndex, {formType: 'hidden'})" class="item-action-button gray"
                    mat-menu-item>
                <mat-icon>person_off</mat-icon>
                <span>{{ 'Прихована роль' | translate }}</span>
            </button>
        </mat-menu>

<!--        && checkPermissions('BILLING_AGREEMENT_EDIT')-->
        <button class="action-button green" [matMenuTriggerFor]="chooseContractTypeMenu"
                *ngIf="(!data.disableAddContract && counterpartyTabs.selectedIndex === 2 )">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'Додати договір' }}</span>
        </button>
        <mat-menu #chooseContractTypeMenu xPosition="before" class="wide-menu">
            <button mat-menu-item class="item-action-button gray" (click)="addContract('BUSINESS_SAAS')">
                <mat-icon class="action-button-icon">terminal</mat-icon>
                <span>{{ 'modules.billing.agreements.types.BUSINESS_SAAS' | translate }}</span>
            </button>
            <button mat-menu-item class="item-action-button gray" (click)="addContract('BUSINESS_ACCOUNTING')">
                <mat-icon class="action-button-icon">person</mat-icon>
                <span>{{ 'modules.billing.agreements.types.BUSINESS_ACCOUNTING' | translate }}</span>
            </button>
        </mat-menu>

        <button (click)="addItem(counterpartyTabs.selectedIndex)" *ngIf="counterpartyTabs.selectedIndex === 3"
                class="action-button green">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'modules.clients.associations.associationViewDialog.tabs.addItem.addManager' | translate }}</span>
        </button>
    </div>
    <mat-tab-group #counterpartyTabs (selectedTabChange)="tabChanged($event)" animationDuration="0ms"
                   class="dialog-tabs no-min-with">
        <mat-tab label="{{'modules.billing.counterParty.viewDialog.tabs.info' | translate}}">
            <div class="counterparty-info">
                <div class="key-value grid main-info">
                    <div class="key">{{ 'modules.billing.companies.companyDialog.labels.type' | translate }}</div>
                    <div class="value">{{'modules.billing.companies.companyTypes.' + data.counterparty.type | translate}}</div>

                    <div class="key">{{ 'modules.billing.companies.companyDialog.labels.code' | translate }}</div>
                    <div class="value">{{data.counterparty?.code ?? '-'}}</div>

                    <div class="key">{{ 'modules.billing.companies.companyDialog.labels.name' | translate }}</div>
                    <div class="value">{{data.counterparty?.name ?? '-'}}</div>

                    <div class="key">{{ 'modules.billing.companies.companyDialog.labels.address' | translate }}</div>
                    <div class="value">{{data.counterparty?.address ?? '-'}}</div>

                    <div class="key">{{ 'modules.billing.companies.companyDialog.labels.director' | translate }}</div>
                    <div class="value">{{data.counterparty?.director ?? '-'}}</div>

                    <div class="key">{{ 'modules.billing.companies.companyDialog.labels.directorPosition' | translate }}</div>
                    <div class="value">{{data.counterparty?.directorPosition ?? '-'}}</div>

                    <div class="key">{{ 'modules.crm.contacts.contactDialog.labels.manager' | translate }}</div>
                    <div class="value">{{data.counterparty?.manager?.name ?? '-'}}</div>

                    <div class="key">{{ 'Тарифний план' }}</div>
                    <div class="value df gap20">
                        <span>{{ 'modules.billing.counterParty.tariffs.' + data.counterparty.tariff | translate }}</span>
                        <span (click)="changeTariff()" *ngIf="checkPermissions('ASSOCIATION_TARIFF_EDIT')"
                              class="add-row">{{ 'Змінити' }}</span>
                        <span (click)="showTariffHistory()" class="show-info">{{ 'Історія змін' }}</span>
                    </div>

                    <div class="key">{{ 'Експериметальний контрагент (Бухгалтерія)' }}</div>
                    <div class="value">
                        <mat-checkbox [checked]="data.counterparty.experimentalFeatures"
                                      [disabled]="!checkPermissions('BILLING_NEW_EDIT')"
                                      (change)="toggleExperimentalFeatures($event.checked)">
                        </mat-checkbox>
                    </div>
                </div>
                <div class="other-info">
<!--                    *ngIf="checkPermissions('ASSOCIATION_CABINET_ACCESS')"-->
                    <button (click)="openCabinet()"
                            class="action-button blue">
                        <mat-icon>redo</mat-icon>
                        <span>{{ 'modules.clients.associations.associationViewDialog.labels.openCabinet' | translate }}</span>
                    </button>
                </div>
            </div>

        </mat-tab>

        <mat-tab [disabled]="!checkPermissions('BILLING_NEW_READ')"
                 label="{{'modules.clients.associations.associationViewDialog.tabs.roles' | translate}}">
            <div class="table-container">
                <mat-table [dataSource]="roleDataSource" class="dialog-table">

                    <ng-container matColumnDef="user">
                        <mat-header-cell *matHeaderCellDef
                                         class="fFlex">{{ 'modules.clients.associations.associationViewDialog.tables.roles.user' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="fFlex jc-s ai-e gap5">
                            <app-user-item
                                    [avatarLink]="element.user?.userAvatar?.replace('s0', 's64-c')"
                                    [canCall]="true"
                                    [phones]="element.user?.userLogin?.number.split(',')"
                                    [userName]="element.user?.userName?.fullName"
                            ></app-user-item>

                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="roleType">
                        <mat-header-cell *matHeaderCellDef style="width: 45px; min-width: 45px; max-width: 45px">

                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 45px; min-width: 45px; max-width: 45px">
                            <mat-icon *ngIf="element.admin" class="main-admin"
                                      matTooltip="Головний адміністратор"
                                      matTooltipClass="tooltip"
                            >settings_accessibility
                            </mat-icon>
                            <mat-icon *ngIf="element.hidden" class="hidden-role"
                                      matTooltip="Приховаена роль"
                                      matTooltipClass="tooltip"
                            >person_off
                            </mat-icon>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <mat-header-cell *matHeaderCellDef class="fFlex">
                            <b>{{ 'modules.clients.associations.associationViewDialog.tables.roles.role' | translate }}</b>
                            <span
                                    class="text-normal">&nbsp;/&nbsp;{{ 'modules.clients.associations.associationViewDialog.tables.possitions' | translate }}</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" [ngClass]="{'error': element.hidden}" class="fFlex">
                            <div class="df-c">
                                <b *ngIf="element.role?.name">{{ element.role?.name }}</b>
                                <span *ngIf="element.user?.position">{{ element.user?.position }}</span>
                                <span
                                        *ngIf="element.hidden">{{ 'modules.clients.associations.associationRoleDialog.labels.hidden' | translate }}</span>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 100px; min-width: 100px; max-width: 100px">{{ 'common.tableActionsColumn' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 100px; min-width: 100px; max-width: 100px" class="df gap5">
                            <button (click)="deleteRole(element)" *ngIf="checkPermissions('ASSOCIATION_GOVERNMENT_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="roleColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: roleColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
        </mat-tab>

        <mat-tab label="{{'Договори'}}"
                 [disabled]="!data.counterparty?.id || (!this.checkPermissions('BILLING_NEW_READ') && !this.checkPermissions('BILLING_SINGLE_CONTRACT_EDIT'))">
            <div class="table-container">
                <mat-table [dataSource]="contractsDataSource" class="dialog-table">
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef class="fFlex">{{ 'Договір' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="fFlex">
                            {{ element.name }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef style="width: 150px; min-width: 150px; max-width: 150px;">{{ 'modules.billing.agreements.list.table.amount' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 150px; min-width: 150px; max-width: 150px;">
                            {{ element.amounts.organizationsAmount | currency:'UAH':'грн.':'0.2-2' }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 120px; min-width: 120px; max-width: 120px">{{ 'common.tableActionsColumn' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 120px; min-width: 120px; max-width: 120px" class="df gap5">
                            <button class="item-action-button gray" (click)="editContract(element)" *ngIf="!data.disableAddContract && checkPermissions('BILLING_AGREEMENT_EDIT')">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            <button class="item-action-button gray" (click)="deleteContract(element)"
                                    *ngIf="!data.disableAddContract && checkPermissions('BILLING_AGREEMENT_EDIT') && !element?.counterParty">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="columns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: columns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
        </mat-tab>

<!--        [disabled]="!checkPermissions('ORG_MANAGER_READ') && !checkPermissions('ASSOCIATION_EDIT')"-->
        <mat-tab
                 label="{{'Managers DAH'}}">
            <div class="table-container">
                <mat-table [dataSource]="managerDataSource" class="dialog-table">

                    <ng-container matColumnDef="manager">
                        <mat-header-cell *matHeaderCellDef
                                         class="fFlex">{{ 'modules.clients.associations.associationViewDialog.tables.managers.manager' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="fFlex">{{ element.manager.name }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <mat-header-cell *matHeaderCellDef
                                         class="fFlex">{{ 'modules.clients.associations.associationViewDialog.tables.managers.role' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element"
                                  class="fFlex">{{ 'modules.references.administrators.positions.' + element.position | translate }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 80px; min-width: 80px; max-width: 80px">{{ 'common.tableActionsColumn' | translate }}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 80px; min-width: 80px; max-width: 80px" class="df gap5">
<!--                            *ngIf="checkPermissions('ASSOCIATION_EDIT') || checkPermissions('ORG_MANAGER_EDIT')"-->
                            <button (click)="deleteManager(element)"  [disabled]="!element.id"
                                    class="item-action-button gray">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="managerColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: managerColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
